import {
  httpApps,
  httpAdminCompanyLocation,
  httpDealer,
} from "../helper/http-common";

class SelectYourGemStoneService {
  GetSimilarGemStonesByPage(inputData, pageName) {
    if (pageName == "Mined") {
      return httpApps.post("GemStoneLink/LoadGemStones", inputData);
    }
  }

  GetDiamondLInkFancyDiamonds(inputData) {
    return httpApps.post("DiamondLink/GetDiamondLInkFancyDiamonds", inputData);
  }

  GetGemstoneLInkMinedGemstones(inputData) {
    return httpApps.post("GemStoneLink/LoadGemStones", inputData);
  }
  LabGrownDiamonds(inputData) {
    return httpApps.post("DiamondLink/LabGrownDiamonds", inputData);
  }
  LoadCompareGemStonesList(inputData) {
    return httpApps.post("GemStoneLink/LoadCompareGemStonesList", inputData);
  }
  GetGemStoneLinkFiltersDropHint(inputData) {
    return httpApps.post(
      "GemStoneLink/GetGemStoneLinkFiltersDropHint",
      inputData
    );
  }
  GetGemStoneLinkFiltersRequestMoreInfo(inputData) {
    return httpApps.post(
      "GemStoneLink/GetGemStoneLinkFiltersRequestMoreInfo",
      inputData
    );
  }
  GetGemStoneLinkFiltersEmailToFriend(inputData) {
    return httpApps.post(
      "GemStoneLink/GetGemStoneLinkFiltersEmailToFriend",
      inputData
    );
  }
  GetGemStoneLinkFiltersScheduleviewing(inputData) {
    return httpApps.post(
      "GemStoneLink/GetGemStoneLinkFiltersScheduleviewing",
      inputData
    );
  }
  GetnNavigationList(inputData) {
    return httpApps.post("DiamondLink/GetnNavigationList", inputData);
  }
  GetGemStoneLinkFiltersViewStateData(inputData) {
    return httpApps.post(
      "GemStoneLink/GetGemStoneLinkFiltersViewStateData",
      inputData
    );
  }

  GetGemStoneLinkFiltersRequestCertificate(inputData) {
    return httpApps.post(
      "GemStoneLink/GetGemStoneLinkFiltersRequestCertificate",
      inputData
    );
  }
  LabFilter(inputData) {
    return httpApps.post("GemStoneLink/LabFilter", inputData);
  }
  GetDiamondLInkFancyDiamondsFiltersData(inputData) {
    return httpApps.post(
      "DiamondLink/GetDiamondLInkFancyDiamondsFiltersData",
      inputData
    );
  }
  GetGemStoneLinkFiltersRequest(inputData) {
    return httpApps.post("GemStoneLink/GetGemStoneLinkFiltersRequest", inputData);
  }
  GetDealerInformation(inputData) {
    return httpApps.post("DiamondLink/GetDealerInformation", inputData);
  }
  GetDealerLocationData(inputData) {
    return httpApps.post("DiamondLink/GetDealerLocationData", inputData);
  }
  GetDealerSocialLinksData(inputData) {
    return httpApps.post("DiamondLink/GetDealerSocialLinksData", inputData);
  }
  GetOptionsDetails(inputData) {
    return httpApps.post("GemStoneLink/GetOptionsDetails", inputData);
  }
  GetLocationDetails(inputData) {
    return httpAdminCompanyLocation.post(
      "/Profile/LocationLoadDetailsForML",
      inputData
    );
  }

  GetLocationByID(inputData) {
    return httpAdminCompanyLocation.post(
      "/Profile/LocationByID",
      inputData
    );
  }

  ProductTracking(inputData) {
    return httpApps.post("DiamondLink/ProductTracking", inputData);
  }
  DiamondTracking(inputData) {
    return httpApps.post("DiamondLink/DiamondTracking", inputData);
  }
  GetMenuList(inputData) {
    return httpAdminCompanyLocation.post("/Tools/GetMenuListForML", inputData);
  }
  CompanyWhileLabel() {
    return httpDealer.get("/Dashboard/CompanyWhileLabelForML");
  }
  GetLanguage(inputData) {
    return httpAdminCompanyLocation.post(
      "/SelectLenguage/SelectlanguageForDelarForML",
      inputData
    );
  }
}

export default new SelectYourGemStoneService();
